import translations from './translations'

translations.add('es', {
    selectBank: 'elija su banco'
})
